import React from 'react';
import { UserDataContext } from './userDataContext';

function withUserData(WrappedComponent) {
    return props => (
        <UserDataContext.Consumer>
            {userData => (
                <WrappedComponent
                    {...props}
                    userData={userData}
                />
            )}
        </UserDataContext.Consumer>
    );
}

export default withUserData;



// WEBPACK FOOTER //
// ./src/EeckmanClientInfo/withUserData.js